import React, { useEffect } from 'react';
import classnames from 'classnames';
import { isCopilotHidden } from 'src/models/appConfig/selectors';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import ChildComponent from 'src/workspace/childComponent';
import Body from './body';
import Footer from './footer';
import Header from './header';
import { isAgentAIEnabled } from './selector';
import { connectWebSocket, disconnectWebSocket } from './thunk';
import styles from './index.module.scss';

function CopilotV2({
  classNames,
  version,
  config,
}: {
  classNames: string;
  version?: 'default' | 'workflow';
  config?: Record<string, any>;
}) {
  const dispatch = useAppDispatch();
  const hideCopilot = useAppSelector((state) => isCopilotHidden(state));
  const copilotClasses = classnames(classNames, styles.copilotv2);
  const agentAI = useAppSelector(isAgentAIEnabled);
  const chatSessionId = Math.random().toString(36).substring(2, 15);
  useEffect(() => {
    if (!hideCopilot) {
      dispatch(connectWebSocket());
    } else {
      dispatch(disconnectWebSocket());
    }
  }, [dispatch, hideCopilot]);

  if (hideCopilot) return null;

  return (
    <div className={copilotClasses}>
      <Header version={version} />
      {agentAI ? (
        <ChildComponent id="COPILOT_AGENT" />
      ) : (
        <>
          <Body version={version} chatSessionId={chatSessionId} />
          <Footer
            version={version}
            chatSessionId={chatSessionId}
            context={config}
          />
        </>
      )}
    </div>
  );
}

export default CopilotV2;
